/**
 * Represents the global configuration variables for the application.
 * @author @CorradoSurmanowicz
 */
type GlobalVars = {
  proxy: string;
  hostname: string;
  port: string;
  protocol: string;
};

declare global {
  // Extends the globalThis type to include the app property
  // @author @CorradoSurmanowicz
  var app: GlobalVars;
}

globalThis.app = {
  proxy: window.location.origin, // The proxy URL for API requests e.g. http://localhost
  hostname: window.location.hostname, // The hostname for the API requests e.g. localhost
  port: window.location.port, // The port for the API requests e.g. 5000
  protocol: window.location.protocol, // The protocol for the API requests e.g. http:
};

if (process.env.NODE_ENV === "development") {
  globalThis.app.proxy = "http://localhost:5000";
  globalThis.app.hostname = "localhost";
  globalThis.app.port = "5000";
  globalThis.app.protocol = "http:";
}

// Freeze so these can only be defined in this file.
Object.freeze(globalThis.app);

export {};
